import cls from './TimeDisplayTitle.module.scss';


interface TimeDisplayTitleProps {
    onChangeDispayFormat: () => void;
    elapsedTime: string;
    totalDuration: string;
    timeDisplayFormat: string;
}

const TimeDisplayTitle = ({onChangeDispayFormat, elapsedTime, totalDuration, timeDisplayFormat}: TimeDisplayTitleProps) => {
    return (
        <button className={cls.button} onClick={onChangeDispayFormat}>
            {timeDisplayFormat === "normal" ?
                `${elapsedTime}/${totalDuration}`
                :
                `${elapsedTime}`
            }
        </button>
    );
}

export default TimeDisplayTitle;